import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!

  return (_openBlock(), _createBlock(_component_Badge, {
    severity: _ctx.$enums.Severity.NEUTRAL
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("Coming soon")
    ])),
    _: 1
  }, 8, ["severity"]))
}